.root {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: var(--dib-surface);
    padding: var(--mantine-spacing-lg);
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: var(--input-height-xs);
    margin-bottom: var(--mantine-spacing-xs);
}

.searchIcon {
    height: var(--input-height-xs);
    width: var(--input-height-xs);
}

.searchWrapper {
    position: relative;
    display: flex;
    align-items: center;
    height: var(--input-height-xs);
}

.searchRoot {
    height: var(--input-height-xs);
}

.searchInput {
    font-size: var(--mantine-font-size-xs);
    background-color: transparent;
    border: 1px solid rgba(15, 15, 20, 0.5);
    border-radius: 0;
    color: var(--dib-ink);
    width: 140px;
    transition: border var(--transition-duration-fast) var(--transition-ease-snappy);

    &::placeholder {
        color: rgba(15, 15, 20, 0.5);
    }

    &:hover {
        border-color: var(--dib-ink);
    }

    &:focus {
        border-color: var(--mantine-color-dibblue-5);
        outline: 1px solid var(--mantine-color-dibblue-5);
    }
}

.title {
    font-size: var(--mantine-font-size-md);
    font-weight: 500;
    color: var(--dib-ink);
}

.viewAll {
    font-size: var(--mantine-font-size-sm);
    color: var(--dib-ink);
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

.description {
    font-size: var(--mantine-font-size-sm);
    color: color-mix(in srgb, var(--dib-ink) 65%, transparent);
    margin-bottom: var(--mantine-spacing-xs);
}

.expandButton {
    align-self: flex-start;
    font-size: var(--mantine-font-size-sm);
    color: color-mix(in srgb, var(--dib-ink) 65%, transparent);
    margin-top: auto;
    padding-top: var(--mantine-spacing-sm);

    &:hover {
        text-decoration: underline;
    }
}

/* First-load entrance: the column falls into place while its rows fade in
   from the left (matching the sidebar). animation-delay is set inline per
   index to stagger them. */
@keyframes columnIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes rowIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.columnAnimate {
    animation: columnIn 0.4s var(--transition-ease-snappy, ease) both;
}

.rowAnimate {
    animation: rowIn 0.35s var(--transition-ease-snappy, ease) both;
}

@media (prefers-reduced-motion: reduce) {
    .columnAnimate,
    .rowAnimate {
        animation: none;
    }
}

.emptyText {
    font-size: var(--mantine-font-size-sm);
    color: color-mix(in srgb, var(--dib-ink) 50%, transparent);
}

.sectionLabel {
    font-weight: 700;
    font-size: var(--mantine-font-size-xs);
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--dib-ink);
    padding-top: var(--mantine-spacing-xl);
    padding-bottom: 4px;
}
